var exports = {
  "kL": "EmptySlate.module__container___Z1Zzdl",
  "O5": "EmptySlate.module__containerFullHeight___Z1Zzdl",
  "Kk": "EmptySlate.module__icon___Z1Zzdl",
  "DD": "EmptySlate.module__title___Z1Zzdl",
  "h_": "EmptySlate.module__description___Z1Zzdl",
};

module.exports = exports;
